import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";
import { ClientModelInputData } from "../types";

export const useClientModelInput = (model_id: string) => {
  return useQuery({
    queryKey: ["client", "model", "input", model_id],
    enabled: model_id.length > 0,
    queryFn: ({ signal }) =>
      axios
        .get(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/${model_id}/input`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ClientModelInputData;
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
